<template>
  <ProductTitledBlock
    v-if="!model.hidden && master && masterDescription && masterDescription.content"
    :title="model.title || $t('shared.catalog.product_details.master_description_block_title')"
    image-src="/static/images/custom/description.png"
    icon=""
  >
    <VcCollapsibleContent max-height="12rem">
      <VcMarkdownRender :src="masterDescription.content" />
    </VcCollapsibleContent>
  </ProductTitledBlock>

  <ProductTitledBlock
    v-if="!model.hidden && description && description.content"
    :title="model.title || $t('shared.catalog.product_details.description_block_title')"
    icon=""
    image-src="/static/images/custom/description.png"
  >
    <VcCollapsibleContent max-height="18.75rem" class="text-base text-neutral-600">
      <VcMarkdownRender icon="" :src="description.content" />
    </VcCollapsibleContent>
  </ProductTitledBlock>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ProductTitledBlock from "../product-titled-block.vue";
import type { Product, DescriptionType } from "@/core/api/graphql/types";

interface IProps {
  product: Product;
  master?: Product;
  model: {
    title?: string;
    hidden?: boolean;
  };
  isCollapsible?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isCollapsible: true,
});

const description = computed<DescriptionType | undefined>(
  () => props.product.descriptions.filter((desc) => desc.reviewType != "Properties")[0] ?? undefined,
);
const masterDescription = computed<DescriptionType | undefined>(
  () => props.master!.descriptions.filter((desc) => desc.reviewType != "Properties")[0] ?? undefined,
);
</script>
